// SF6 — what changed, without logging in.
//
// Raised on finalised days only. An alert on a figure Amazon is still revising
// teaches the seller to ignore alerts, which costs more than the alert saves.
import React from 'react';
import { FiAlertTriangle, FiInfo } from 'react-icons/fi';
import s from '../AdsAnalytics.module.css';

export default function Alerts({ data, loading }) {
  if (loading && !data) return <div className={s.empty}>Loading…</div>;
  if (!data) return null;

  if (!data.alerts?.length) {
    return (
      <div className={s.empty}>
        <p>{data.note || 'Nothing crossed a threshold since the period before.'}</p>
        {data.suppressed?.length > 0 && (
          <p className={s.hint}>
            Held back as expected during {data.event}: {data.suppressed.join('; ')}.
          </p>
        )}
      </div>
    );
  }

  return (
    <>
      {data.suppressed?.length > 0 && (
        <p className={s.hint} style={{ marginBottom: 12 }}>
          Held back as expected during {data.event}: {data.suppressed.join('; ')}. A sale lifts
          spend and ACOS by design, and only counts against you if sales did not rise with it.
        </p>
      )}
      <div className={s.changeList}>
        {data.alerts.map((a, i) => (
          <div key={`${a.kind}-${a.subject}-${i}`}
               className={`${s.change} ${a.severity === 'high' ? s.changeHigh : s.changeMedium}`}>
            <span className={s.changeIcon}>
              {a.severity === 'high' ? <FiAlertTriangle /> : <FiInfo />}
            </span>
            <div>
              <div className={s.changeHead}>{a.subject}</div>
              <div className={s.changeLine}>{a.headline}</div>
              {a.detail && <div className={s.hint}>{a.detail}</div>}
            </div>
          </div>
        ))}
      </div>
      <p className={s.hint} style={{ marginTop: 10 }}>
        Raised on finalised days only — everything after {data.finalised_through} is still
        being revised by Amazon and is not alerted on.
      </p>
    </>
  );
}
